export default function() {
    return {
        survey: false,
        success: false,
        error: false,
        errorField: false,
        replyText: null,
        surveyAnswers: {
            agencyObservations: null,
            agencyAnswerDate: null,
            observations: '',
            tripRank: 0,
            placeRank: 0,
            agencyRank: 0,
            companyRank: 0
        }
    }
}
